
"use strict";
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { DIALOG_AUX_FUNCTIONS } from "../util/classes";
import { Whisper } from "../util/classes";
import { UTL } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { TRANS } from "../util/classes";

/**
 * DIALOG20 Static Class
 * דיאלוג אישור (Confirmation) - משמש בדרך כלל לאישור מחיקה
 */
export class DIALOG20 {
    // --- Components (Static Properties) ---
    public static overlay_element: HTMLDivElement = null; // must be public called from outside
    private static popup_element: HTMLElement = null;
    private static caption_element: HTMLElement = null;
    private static case_element: HTMLElement = null;
    private static close_button_element: HTMLSpanElement = null;
    private static defo_button_element: HTMLElement = null;
    private static panel_element: HTMLElement = null;
    private static ok_button_element: HTMLElement = null;
    private static cancel_button_element: HTMLElement = null;

    // --- State Variables ---
    private static MD_FLAG: boolean = false;
    private static defo_button_is_clicked: boolean = false;
    private static Vamod_MouseX: number = 0;
    private static Vamod_MouseY: number = 0;
    private static Vamod_ModalWindowLeftX: number = 0;
    private static Vamod_ModalWindowTopY: number = 0;

    private static par_callback_function: Function = null;
    private static par_text_content: string = "";

    private static readonly BID = {
        UNDEFINED: 0,
        OK: 1,
        CANCEL: 2,
    };

    private static var_current_pseudo_focused_btn: number = DIALOG20.BID.OK;

    // --- Methods ---

    public static refresh_pseudo_focus_for_all_buttons(): void {
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG20.ok_button_element, DIALOG20.var_current_pseudo_focused_btn == DIALOG20.BID.OK);
        DIALOG_AUX_FUNCTIONS.put_pseudo_focus_indcator(DIALOG20.cancel_button_element, DIALOG20.var_current_pseudo_focused_btn == DIALOG20.BID.CANCEL);
    }

    public static respond_tab(): void {
        DIALOG20.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Forward(DIALOG20.var_current_pseudo_focused_btn, DIALOG20.BID.OK, DIALOG20.BID.CANCEL);
        DIALOG20.refresh_pseudo_focus_for_all_buttons();
    }

    public static respond_shift_tab(): void {
        DIALOG20.var_current_pseudo_focused_btn = UTL.GET_NEW_INDEX_Backward(DIALOG20.var_current_pseudo_focused_btn, DIALOG20.BID.OK, DIALOG20.BID.CANCEL);
        DIALOG20.refresh_pseudo_focus_for_all_buttons();
    }

    private static create_overlay_element(): HTMLDivElement {
        const overlay_element = document.createElement("div");
        overlay_element.style.position = "fixed";
        overlay_element.style.top = "0";
        overlay_element.style.left = "0";
        overlay_element.style.width = "100%";
        overlay_element.style.height = "100%";
        overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
        overlay_element.style.zIndex = "1000";
        return overlay_element;
    }

    private static create_popup_element(): HTMLElement {
        const popup_element = document.createElement("div");
        popup_element.id = "id-DIALOG20-popup";
        popup_element.style.position = "absolute";
        popup_element.style.backgroundColor = "#fff";
        popup_element.style.padding = "0px";
        popup_element.style.borderRadius = "8px";
        popup_element.style.width = "320px";
        popup_element.style.textAlign = "center";
        return popup_element;
    }

    private static create_caption_element(): HTMLElement {
        const caption = document.createElement("div");
        caption.textContent = "DIALOG20";
        caption.style.fontSize = "24px";
        caption.style.fontWeight = "bold";
        caption.style.margin = "0px";
        caption.style.padding = "0px";
        caption.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_caption_backgroundColor();
        caption.style.color = DIALOG_AUX_FUNCTIONS.get_caption_forgroundColor();
        caption.style.borderTopLeftRadius = "5px";
        caption.style.borderTopRightRadius = "5px";
        caption.style.userSelect = "none";
        return caption;
    }

    private static create_case_element(): HTMLElement {
        const element = document.createElement("div");
        element.id = "id-DIALOG20-case";
        element.style.backgroundColor = "yellow";
        UTL.remove_outline_for_focusable_element(element);
        element.style.fontSize = "25px";
        element.style.padding = "22px";
        element.style.margin = "auto";
        element.style.fontWeight = "700";
        element.style.direction = "rtl";
        element.textContent = DIALOG20.par_text_content;
        element.style.whiteSpace = "pre-line";
        return element;
    }

    private static create_panel_element(): HTMLElement {
        const buttonsContainer = document.createElement("div");
        buttonsContainer.style.marginTop = "6px";
        buttonsContainer.style.display = "flex";
        buttonsContainer.style.justifyContent = "space-around";
        buttonsContainer.style.backgroundColor = DIALOG_AUX_FUNCTIONS.get_panel_backgroundColor();
        buttonsContainer.style.marginBottom = "6px";
        return buttonsContainer;
    }

    public static overlay_mousedown(event: MouseEvent): void {
        const target_element = event.target as HTMLElement;
        if (target_element == DIALOG20.caption_element) {
            const rect = DIALOG20.popup_element.getBoundingClientRect();
            DIALOG20.MD_FLAG = true;
            DIALOG20.Vamod_MouseX = event.clientX;
            DIALOG20.Vamod_MouseY = event.clientY;
            // שימוש ישיר בערכים מספריים ללא parseFloat
            DIALOG20.Vamod_ModalWindowLeftX = rect.left;
            DIALOG20.Vamod_ModalWindowTopY = rect.top;
        }
        if (target_element == DIALOG20.defo_button_element) {
            DIALOG20.defo_button_is_clicked = true;
        }
    }

    public static overlay_mousemove(event: MouseEvent): void {
        if (DIALOG20.MD_FLAG) {
            const delta_x = event.clientX - DIALOG20.Vamod_MouseX;
            const delta_y = event.clientY - DIALOG20.Vamod_MouseY;
            DIALOG20.popup_element.style.left = (DIALOG20.Vamod_ModalWindowLeftX + delta_x) + "px";
            DIALOG20.popup_element.style.top = (DIALOG20.Vamod_ModalWindowTopY + delta_y) + "px";
        }
    }

    public static overlay_mouseup(event: MouseEvent): void {
        const freezed_defo = DIALOG20.defo_button_is_clicked;
        DIALOG20.MD_FLAG = false;
        DIALOG20.defo_button_is_clicked = false;
        if (!freezed_defo) {
            DIALOG20.case_element.focus();
        }
    }

    public static overlay_keydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            DIALOG20.perform_pseudo_focused_button();
        }
        if (event.key === 'Escape') {
            DIALOG20.perform_cancel();
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'ArrowDown') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (event.key === 'Delete') {
        }
        if (event.key === 'Backspace') {
        }
        if (event.key === 'Tab') {
            event.preventDefault();
            if (!event.shiftKey) DIALOG20.respond_tab();
            else DIALOG20.respond_shift_tab();
        }
        if (event.key === 'F7') {
            event.preventDefault(); // <-- this disables the default behavior
            //UTL.show_which_element_has_focus();
        }

        if (event.key === ' ') {
            event.preventDefault(); // <-- this disables the default behavior
        }
        if (UTL.string_contains_digit(event.key) == true) {
            event.preventDefault(); // <-- this disables the default behavior
        }
    }







    public static perform_pseudo_focused_button(): void {
        if (DIALOG20.var_current_pseudo_focused_btn == DIALOG20.BID.OK) {
            DIALOG20.perform_ok();
        } else if (DIALOG20.var_current_pseudo_focused_btn == DIALOG20.BID.CANCEL) {
            DIALOG20.perform_cancel();
        }
    }

    public static perform_given_pars(p_output_bool: boolean): void {
        if (DIALOG20.par_callback_function != null) {
            document.body.removeChild(DIALOG20.overlay_element);
            // שימוש ב-setTimeout כפי שמוגדר בדרישות הריענון שלך
            setTimeout(DIALOG20.par_callback_function, 0, p_output_bool);
        } else {
            alert("DIALOG20_callback_function != null");
        }
    }

    public static perform_ok(): void {
        DIALOG20.perform_given_pars(true);
    }

    public static perform_cancel(): void {
        DIALOG20.perform_given_pars(false);
    }

    public static perform_defo(): void {
        UTL.show_which_element_has_focus();
    }

    public static create_dialog(p_callback_function: Function, p_info: VECTOR_Info, p_text_content: string): void {
        DIALOG20.par_callback_function = p_callback_function;
        DIALOG20.par_text_content = p_text_content;

        DIALOG20.overlay_element = DIALOG20.create_overlay_element();
        DIALOG20.popup_element = DIALOG20.create_popup_element();
        DIALOG20.caption_element = DIALOG20.create_caption_element();
        DIALOG20.close_button_element = DIALOG_AUX_FUNCTIONS.create_close_button_element();
        DIALOG20.defo_button_element = DIALOG_AUX_FUNCTIONS.create_defo_button_element();

        DIALOG20.case_element = DIALOG20.create_case_element();
        DIALOG20.panel_element = DIALOG20.create_panel_element();
        DIALOG20.ok_button_element = DIALOG_AUX_FUNCTIONS.create_ok_button_element();
        DIALOG20.cancel_button_element = DIALOG_AUX_FUNCTIONS.create_cancel_button_element();

        UTL.MakeElementUnFocusable(DIALOG20.ok_button_element);
        UTL.MakeElementUnFocusable(DIALOG20.cancel_button_element);

        DIALOG20.overlay_element.appendChild(DIALOG20.popup_element);
        DIALOG20.caption_element.appendChild(DIALOG20.close_button_element);
        DIALOG20.caption_element.appendChild(DIALOG20.defo_button_element);
        DIALOG20.popup_element.appendChild(DIALOG20.caption_element);
        DIALOG20.popup_element.appendChild(DIALOG20.case_element);
        DIALOG20.popup_element.appendChild(DIALOG20.panel_element);
        DIALOG20.panel_element.appendChild(DIALOG20.ok_button_element);
        DIALOG20.panel_element.appendChild(DIALOG20.cancel_button_element);

        DIALOG20.overlay_element.addEventListener("mousedown", DIALOG20.overlay_mousedown);
        DIALOG20.overlay_element.addEventListener("mousemove", DIALOG20.overlay_mousemove);
        DIALOG20.overlay_element.addEventListener("mouseup", DIALOG20.overlay_mouseup);
        DIALOG20.overlay_element.addEventListener("keydown", DIALOG20.overlay_keydown);

        DIALOG20.defo_button_element.addEventListener("click", DIALOG20.perform_defo);
        DIALOG20.ok_button_element.addEventListener("click", DIALOG20.perform_ok);
        DIALOG20.cancel_button_element.addEventListener("click", DIALOG20.perform_cancel);
        DIALOG20.close_button_element.addEventListener("click", DIALOG20.perform_cancel);

        document.body.appendChild(DIALOG20.overlay_element);
        UTL.center_popup_element_inside_overlay_element(DIALOG20.popup_element, DIALOG20.overlay_element);

        DIALOG20.var_current_pseudo_focused_btn = DIALOG20.BID.OK;
        DIALOG20.refresh_pseudo_focus_for_all_buttons();
        UTL.MakeElementFocusable(DIALOG20.case_element);
        DIALOG20.case_element.focus();
    }
}